import * as t from "io-ts"

const Organisation = t.intersection([
    t.type({
        organisationName: t.string,
        domains: t.array(t.string),
    }),
    t.partial({
        organisationType: t.string,
        recordType: t.string,
        organisationId: t.string,
        installerIndividualPhoneNumber: t.union([t.string, t.null]),
        organisationPostcode: t.string,
        organisationAddress: t.string,
        organisationAddressLine2: t.string,
        organisationContactNumber: t.string,
    }),
])

export const GetOrgRes = t.type({
    organisation: Organisation,
})

export type TGetOrgRes = t.TypeOf<typeof GetOrgRes>

const Admins = t.array(t.string)

export const GetMyAdminsRes = t.union([
    Admins,
    t.type({
        org_admins: Admins,
    }),
    t.type({
        admins: Admins,
    }),
    t.type({
        orgAdmins: Admins,
    }),
    t.type({
        organisationAdmins: Admins,
    }),
])

export type TGetMyAdminsRes = t.TypeOf<typeof GetMyAdminsRes>
